module.exports = __webpack_public_path__ + "img/drug-1.8b082afe.jpg";